<template lang="pug">
  el-container
    el-header(height="auto")
      el-form(inline label-suffix=":")
        city-select(v-model="city" ev)
        br
        el-form-item(label="开锁时间")
          el-date-picker(
            v-model="unlockTime"
            type="datetimerange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
          )
        el-form-item(label="关锁时间")
          el-date-picker(
            v-model="lockTime"
            type="datetimerange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
          )
        el-form-item
          el-button(
            type="primary"
            icon="el-icon-search"
            :disabled="paramsError"
            :loading="searching"
            @click="search"
            v-action="`ordercenter_bicycle_table`"
          ) 搜索
        el-form-item
          el-button(
            type="primary"
            icon="el-icon-download"
            :disabled="paramsError"
            @click="download"
            v-action="`ordercenter_bicycle_export`"
          ) 导出
    el-main
      grid(
        :remoteMethod="getTableData"
        ref="grid"
        layout="prev, pager, next, jumper"
      )
        -
          var columns = [
            { prop:"mobilePhone", label:"手机号"},
            { prop:"bikeNo", label:"车辆编号"},
            { prop:"startTimeName", label:"开锁时间"},
            { prop:"stopTimeName", label:"关锁时间"},
            { prop:"rideTime", label:"骑行时长(分钟)"},
            { prop:"rideCost", label:"骑行费用(元)"},
            { prop:"rideDistance", label:"骑行距离"},
            { prop:"rideStatusName", label:"订单状态"},
            { prop:"withdrawCount", label:"退款金额"},
          ];
        each item in columns
          el-table-column(
            prop=item.prop
            label=item.label
            v-if=`__action(table.${item.prop})`
          )
</template>

<script>
import { getEvOrderList, downloadEvOrderList } from '@/api/report';
import { getScenicCityList } from '@/api/user';
import grid from '@/components/grid';
import { download } from '@/utils';
import citySelect from '@/components/citySelect';

export default {
  name: 'Order',
  components: {
    grid,
    citySelect,
  },
  data() {
    return {
      city: '',
      searching: false,
      dialogVisible: false,
      lockTime: [],
      unlockTime: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() >= new Date().setHours(0, 0, 0, 0);
        }
      }
    };
  },
  computed: {
    paramsError() {
      const lockTime = this.lockTime || [];
      const unlockTime = this.unlockTime || [];
      return !this.city || (lockTime.length + unlockTime.length === 0);
    },
    table() {
      const handler = {
        get: (target, name) => `ordercenter_bicycle_table_${name}`
      };
      return new Proxy({}, handler);
    }
  },
  mounted() {
  },
  methods: {
    async getTableData(data) {
      const res = await getEvOrderList(data);
      return { data: res.data, total: res.total };
    },
    formatParams() {
      return {
        cityGuid: this.city,
        lockTimeBegin: this.lockTime && this.lockTime[0],
        lockTimeEnd: this.lockTime && this.lockTime[1],
        unlockTimeBegin: this.unlockTime && this.unlockTime[0],
        unlockTimeEnd: this.unlockTime && this.unlockTime[1],
      };
    },
    async download() {
      const res = await downloadEvOrderList(this.formatParams());
      download(res.data.body);
    },
    async search() {
      this.searching = true;
      await this.$refs.grid.loadData(this.formatParams());
      this.searching = false;
    },
    async getScenicCityList() {
      const res = await getScenicCityList();
      this.scenicCityList = res.data || [];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/order/evOrder.vue?31635656